var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLinkedIn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11169_299047)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4489 20.4493H16.8929V14.8803C16.8929 13.5523 16.8691 11.8428 15.0434 11.8428C13.1912 11.8428 12.9078 13.2897 12.9078 14.7837V20.449H9.35188V8.99684H12.7656V10.5619H12.8134C13.155 9.97775 13.6487 9.4972 14.2419 9.17142C14.835 8.84564 15.5054 8.68685 16.1817 8.71194C19.7859 8.71194 20.4504 11.0827 20.4504 14.1669L20.4489 20.4493ZM5.33938 7.4315C4.19966 7.43169 3.27557 6.50787 3.27538 5.36816C3.27519 4.22844 4.19891 3.30434 5.33863 3.30416C6.47835 3.30387 7.40244 4.22769 7.40263 5.36741C7.40273 5.91472 7.18541 6.43966 6.79848 6.82675C6.41155 7.21384 5.8867 7.43138 5.33938 7.4315ZM7.11744 20.4494H3.55766V8.99684H7.11735V20.4493L7.11744 20.4494ZM22.2217 0.00162467H1.77079C0.804224 -0.00925033 0.0115684 0.765031 -0.000244141 1.73159V22.2678C0.0111934 23.2348 0.803756 24.0099 1.77069 23.9997H22.2217C23.1907 24.0117 23.9863 23.2367 23.9998 22.2678V1.73C23.986 0.761562 23.1902 -0.0126253 22.2217 3.09196e-05",
    fill: "#0A66C2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11169_299047"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedIn);
export default __webpack_public_path__ + "static/media/LinkedIn.bffd697552a8a8f7eec36f92eb0cd0bf.svg";
export { ForwardRef as ReactComponent };